module.exports = __webpack_public_path__ + "img/vehicle-checklist.bc6e0959.png";